import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { PANEL_SWITCHER_API } from "@/_helpers/urls";
import { PANEL_SWITCHER_MUTATIONS } from "../mutation-types";
import { PANEL_SWITCHER_ACTIONS } from "../action-types";
import Cookies from "js-cookie";

// State
const state = {
    ssoUrl: null,
    isLoading: false,
    error: null,
};

// Getters
const getters = {};

// Mutations
const mutations = {
    [PANEL_SWITCHER_MUTATIONS.SET_LOADING](state, isLoading) {
        state.isLoading = isLoading;
    },
    [PANEL_SWITCHER_MUTATIONS.SET_ERROR](state, error) {
        state.error = error;
    },
    [PANEL_SWITCHER_MUTATIONS.SET_SSO_URL](state, url) {
        state.ssoUrl = url;
    }
};

// Actions
const actions = {
    async [PANEL_SWITCHER_ACTIONS.SWITCH_TO_PARTNER]({ commit }) {
        commit(PANEL_SWITCHER_MUTATIONS.SET_LOADING, true);
        commit(PANEL_SWITCHER_MUTATIONS.SET_ERROR, null);

        try {
            const url = PANEL_SWITCHER_API.SWITCH_TO_PARTNER;
            const response = await HTTP().get(url);

            if (response.status === 200 && response.data.type === 'success') {
                commit(PANEL_SWITCHER_MUTATIONS.SET_SSO_URL, response.data.ssoUrl);
                const token = response.data.token;
                const ssoUrl = response.data.ssoUrl;

                Cookies.set('partner_panel', JSON.stringify({
                    authentication: { token }
                }), {
                    expires: 1,
                    domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
                    secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
                    sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
                });

                // Redirect to partner panel with token in URL
                window.location.href = ssoUrl;
            } else {
                commit(PANEL_SWITCHER_MUTATIONS.SET_ERROR, response.data.message || 'Failed to switch panel');
                toast.error(response.data.message || 'Failed to switch panel');
            }
        } catch (error) {
            console.error(error);
            commit(PANEL_SWITCHER_MUTATIONS.SET_ERROR, 'Failed to switch panel');
            toast.error('Failed to switch panel');
        } finally {
            commit(PANEL_SWITCHER_MUTATIONS.SET_LOADING, false);
        }
    }
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions
};